import React from 'react';
import { Sparkles, CheckCircle, AlertTriangle } from 'lucide-react';
import type { useApplicationDetail } from '../../hooks/useApplicationDetail';

interface Props { h: ReturnType<typeof useApplicationDetail>; }

export const AIAnalysisSection: React.FC<Props> = ({ h }) => {
  const { application } = h;
  if (!application?.aiAnalysis) return null;
  // DB stores AI fields as JSON strings, runtime shape varies
  const ai = application.aiAnalysis as Record<string, any>;

  return (
    <div className="bg-gradient-to-br from-purple-50 to-blue-50 rounded-lg shadow-lg p-6 border-2 border-purple-200">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center">
          <Sparkles className="text-purple-600 mr-2" size={24} />
          <h2 className="text-xl font-bold text-purple-900">Analiza AI</h2>
        </div>
        <span className="text-xs text-purple-600">{new Date(ai.generated_at).toLocaleString('pl-PL')}</span>
      </div>
      <div className="space-y-4">
        <div>
          <h3 className="font-semibold text-purple-900 mb-2">Profesjonalny opis</h3>
          <p className="text-sm text-gray-700 bg-white p-3 rounded">{ai.professional_description}</p>
        </div>
        {ai.strengths && (
          <div>
            <h3 className="font-semibold text-green-700 mb-2">Mocne strony</h3>
            <ul className="space-y-1">
              {JSON.parse(ai.strengths).map((s: string, idx: number) => (
                <li key={idx} className="text-sm text-gray-700 flex items-start">
                  <CheckCircle className="text-green-500 mr-2 flex-shrink-0 mt-0.5" size={16} />
                  {s}
                </li>
              ))}
            </ul>
          </div>
        )}
        {ai.risks && (
          <div>
            <h3 className="font-semibold text-red-700 mb-2">Ryzyka</h3>
            <ul className="space-y-1">
              {JSON.parse(ai.risks).map((r: string, idx: number) => (
                <li key={idx} className="text-sm text-gray-700 flex items-start">
                  <AlertTriangle className="text-red-500 mr-2 flex-shrink-0 mt-0.5" size={16} />
                  {r}
                </li>
              ))}
            </ul>
          </div>
        )}
        {ai.overall_assessment && (
          <div>
            <h3 className="font-semibold text-purple-900 mb-2">Ogólna ocena</h3>
            <p className="text-sm text-gray-700 bg-white p-3 rounded">{ai.overall_assessment}</p>
          </div>
        )}
      </div>
    </div>
  );
};
